import { useUser } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchActivitySwings } from '@data';

export const getActivitySwingsKey = (activityId: number) => ['swings', 'activity', activityId] as const;

export const useActivitySwings = (activityId = -1) => {
    const { data: user } = useUser();

    return useQuery({
        queryKey: getActivitySwingsKey(activityId),
        queryFn: () => fetchActivitySwings(activityId),
        enabled: activityId > 0 && !!user,
        // Prevents booth cache clear
        refetchOnMount: false,
    });
};
